import React, { useState } from "react";
import { Button, message, Modal, Row, Divider, Col, Space, Spin } from "antd";
import axios from "axios";
import { lawyer_send_debs, HEADERS_BASIC90 } from "../api/apiCent90";

function ModalS4ToS1({ data, onSuccess, disabled }) {
  const [openModalS4, setOpenModalS4] = useState(false); //เปิดModal2
  const [loading, setLoading] = useState(false); // ✅ เพิ่ม
  // console.log("data1233", data);

  //ยกเลิก ModalCel1
  const modalCel1 = () => {
    if (loading) return; // ✅ กันปิดระหว่างโหลด
    setOpenModalS4(false);
  };
  const showModal1 = () => {
    setOpenModalS4(true);
  };

  const handleOpenS4 = async () => {
    setLoading(true); // ✅ เริ่ม loading
    try {
      const res = await axios.post(
        lawyer_send_debs,
        {
          wdrId: data?.wdrId,
          note: "กฎหมายตีงานกลับ",
          user: "admin888",
        },
        {
          headers: HEADERS_BASIC90,
        },
      );
      const dataB = res.data;
      if (!dataB || dataB.length === 0) {
        message.warning("ไม่มีข้อมูล");
        return;
      }
      message.success("บันทึกสำเร็จ");
      setOpenModalS4(false); // ✅ ปิดหลังสำเร็จ
      if (onSuccess) onSuccess(); // ✅ reload ตาราง
    } catch (err) {
      console.log(err);
      message.error("ไม่สำเร็จ");
    } finally {
      setLoading(false); // ✅ หยุด loading เสมอ
    }
  };
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {" "}
      <Button
        color="danger"
        variant="solid"
        onClick={showModal1}
        disabled={disabled}
        title={disabled ? "ยังไม่ถึงรอบการส่ง" : undefined}
      >
        ยกเลิก
      </Button>
      <Modal
        open={openModalS4}
        onCancel={modalCel1}
        footer={[null]}
        closeIcon={false}
        width={400}
        maskClosable={false}
      >
        <Spin spinning={loading} tip="กำลังบันทึก...">
          {" "}
          {/* ✅ ครอบ Spin */}
          <Row>
            <Divider orientation="center">
              <b>ยืนยันยกเลิกเคส</b>
            </Divider>
            <Col span={24} style={{ marginBottom: "10px" }}>
              เลขสัญญา: {data?.contno}
            </Col>

            <Col span={24} style={{ textAlign: "right" }}>
              <Space>
                <Button
                  type="primary"
                  onClick={handleOpenS4}
                  loading={loading} // ✅ ปุ่มแสดง loading
                  disabled={loading}
                >
                  ยืนยัน
                </Button>
                <Button
                  type="default"
                  danger
                  onClick={modalCel1}
                  disabled={loading} // ✅ กดไม่ได้ตอนโหลด
                >
                  ยกเลิก
                </Button>
              </Space>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </div>
  );
}
export default ModalS4ToS1;
